import Theme from '@adsk/alloy-react-theme';

export const fieldWrapperStyle = {
  'paddingBottom': '22px',
  '&:last-child': {
    paddingBottom: '10px',
  },

  'h3': {
    ...Theme.typography.heading4,
    display: 'inline-block',
    marginTop: '0',
    marginBottom: '5px',
    paddingRight: '7px',
  },

  '& > p': {
    ...Theme.typography.bodyMedium,
    margin: '0',
    lineHeight: '22px',
    color: Theme.colors.charcoal900,
  },

  '& > div.tooltip-wrapper': {
    display: 'inline-block',

    svg: {
      verticalAlign: 'text-bottom',
      color: Theme.colors.charcoal400,
    },
  },
};

export const requiredStyle = {
  color: Theme.colors.red500,
};
